import {
	Alert,
	type AlertAction,
	AlertSemantic,
	type AlertSemantic as AlertSemanticType,
} from "@/components/Molecules/Alert/Alert";

export type ToastColor =
	| "brand"
	| "gray"
	| "error"
	| "warning"
	| "success"
	| "info";

export interface ToastProps {
	id: string;
	color: ToastColor;
	/**
	 * @deprecated Prefer putting the full message in `message`.
	 * Kept for call-site compatibility; ignored visually by the DS Alert toast.
	 */
	addonText?: string;
	/** Primary toast title (Alert `title`). */
	message: string;
	/** Optional supporting text under the title (Alert `description`). */
	description?: string;
	/**
	 * @deprecated Alert dismiss is always shown. Kept for call-site compatibility.
	 */
	showCloseButton?: boolean;
	onClose?: () => void;
	/** Optional primary action (e.g. Retry on save-failure toasts). */
	primaryAction?: AlertAction;
}

const COLOR_TO_SEMANTIC: Record<ToastColor, AlertSemanticType> = {
	brand: AlertSemantic.Brand,
	gray: AlertSemantic.Gray,
	error: AlertSemantic.Error,
	warning: AlertSemantic.Warning,
	success: AlertSemantic.Success,
	info: AlertSemantic.Info,
};

/**
 * Toast wrapper around DS Alert (`type="toast"`).
 *
 * Prefer `showSuccessToast` / `showErrorToast` from `@/utils/toast.utils`.
 *
 * @see Figma Alert Toast 4618:68258
 */
export function Toast({
	color,
	message,
	description,
	id,
	onClose,
	primaryAction,
}: ToastProps) {
	return (
		<div id={id} className="w-full">
			<Alert
				type="toast"
				semantic={COLOR_TO_SEMANTIC[color]}
				title={message}
				description={description}
				onDismiss={onClose}
				primaryAction={primaryAction}
			/>
		</div>
	);
}
